export default __webpack_public_path__ + "static/media/V680_C_BD.2f0814c2.pdf";